export const CONFIRMATION_DIALOG__CANCEL_SITE_ARTICLE = 'CONFIRMATION_DIALOG__CANCEL_SITE_ARTICLE';
